bam-skiplink {
  display: block;
  
  a, button {
    color: var(--bal-color-primary);
    position: fixed;
    top: -100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: var(--bal-color-white);
    border: none;
    appearance: none;
    border-radius: 4px;
    padding: 10px;
    z-index: 9998;
    transition: top 0.2s ease-in-out;
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    white-space: nowrap;
    width: 1px;

    &.hidden {
      display: none;
      padding: 0;
    }

    &:focus,
    &:focus-within {
      clip: auto;
      height: auto;
      overflow: auto;
      width: auto;
      padding-top: 4px;
      padding-bottom: 4px;
      box-shadow:
      0 0 0 4px var(--bal-color-primary),
      0 0 0 6px var(--bal-color-white),
      0 0 0 10px var(--bal-color-purple-6);
      top: 10px;
    }
  }
}
